<template>
    <div class='store-lookup-container'>
        <div class="home-store">
            <Field id='postcode_store_lookup' label="Store Lookup"  :errors='errors' >
                <input type="text" autocomplete="off" v-model='postcode'  placeholder="Postcode" @keydown="onEnterPress"/>
            </Field>
        </div>
        <Button  class="search-button" text='search' theme='dark' @click='getNearestStores'/>
    </div>
</template>
<script>
import Field from '@/ecom/components/fields/Field.vue';
import Button from '@/ecom/components/buttons/Button.vue';
export default {
    components: {Field, Button},
    emits: ['postcodeListener'],
    props:['reset_postcode', 'errors'],
    data(){
        return{
            postcode: '',
        }
    },
    methods:{
        onEnterPress(e){
            if(e.keyCode == 13){
                this.$emit('postcodeListener', this.postcode);
            }
        },
        getNearestStores() {
            this.$emit('postcodeListener', this.postcode);
        }
    },
    watch:{
        'reset_postcode': function(new_val){
            this.postcode = new_val;
        }
    }
}
</script>
<style lang="scss" scoped>
.home-store{
    width: 300px;
}
.search-button{
    margin-top: 30px;
    width: 130px;
    height: 50px;
    @media(max-width: 768px){
        margin-top: 0px;
    }
}
.store-lookup-container{
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
}
</style>
